import React from "react";
import { BotonCancelarSinLetras, BotonLetras } from "../Plantillas/Botones";
import ReactTable from "react-table";
import matchSorter from 'match-sorter';
import Header from "../Header";

class DeliveryDespacho extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            motorizados: [
                {
                    id: 1,
                    nombre: "Juan Jose Alberto Mendoza",
                    celular: "971435299",
                    estado: "Disponible"
                },
                {
                    id: 2,
                    nombre: "Pedro Segundo Mendoza Perez",
                    celular: "999999999",
                    estado: "Disponible"
                },
                {
                    id: 3,
                    nombre: "Alberto Jefferson Hernandez Garcia",
                    celular: "999999999",
                    estado: "Ruta"
                },
            ]
        }
    }

    handleAsignarRuta = (motorizado) => {
        this.setState(prevState => ({
            motorizados: prevState.motorizados.map(m => 
                m.id === motorizado.id 
                    ? {...m, estado: "Ruta"} 
                    : m
            )
        }));
        
        if (this.props.onAsignarMotorizado) {
            this.props.onAsignarMotorizado(motorizado);
        }
    }

    handleLiberarMotorizado = (motorizadoId) => {
        this.setState(prevState => ({
            motorizados: prevState.motorizados.map(motorizado => 
                motorizado.id === motorizadoId 
                    ? {...motorizado, estado: "Disponible"} 
                    : motorizado
            )
        }));
    }

    render(){
        const {motorizados} = this.state;
        return(
            <React.Fragment>
                <div className="container mt-3 mb-3">
                    <ReactTable 
                        data={this.state.motorizados}
                        filterable
                        defaultFilterMethod={(filter, row) => 
                            String(row[filter.id]) === filter.value}
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Acción",
                                        filterable: false,
                                        headerClassName: "",
                                        width: 200,
                                        Cell: row => (
                                            <div>
                                                {row.original.estado === "Disponible" ? (
                                                    <button 
                                                        className="btn-verde-mfp-letra-normal"
                                                        onClick={() => this.handleAsignarRuta(row.original)}
                                                    >
                                                        Seleccionar
                                                    </button>
                                                ) : (
                                                    <span className="text-muted">No disponible</span>
                                                )}
                                            </div>
                                        )
                                    },
                                    {
                                        Header: "Estado",
                                        id: "estado",
                                        width: 150,
                                        accessor: d => d.estado,
                                        filterMethod: (filter, rows) => matchSorter(rows, filter.value, {keys: ["estado"]}),
                                        filterAll: true,
                                        Cell: row => (
                                            <span className={`badge ${
                                                row.value === "Disponible" ? "badge-success" : "badge-danger"
                                            }`}>
                                                {row.value}
                                            </span>
                                        )
                                    },
                                    {
                                        Header: "Nombre",
                                        id:"nombre",
                                        width: 300,
                                        accessor: d => d.nombre,
                                        filterMethod: (filter, rows) => matchSorter(rows, filter.value, {keys: ["nombre"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Celular",
                                        id:"celular",
                                        width: 150,
                                        accessor: d => d.celular, 
                                        filterMethod: (filter, rows) => 
                                            matchSorter(rows, filter.value, {
                                                keys: ["celular"]
                                            }),
                                        filterAll: true,
                                        Cell: row => (
                                            <div style={{textAlign:"center"}}>
                                              {row.value}
                                            </div>
                                        )
                                    }
                                ]
                            }
                        ]}
                        defaultPageSize={5}
                        showPagination={false}
                        className="-striped -highlight"
                        previousText='Anterior'
                        nextText='Siguiente'
                        loadingText='Cargando...'
                        noDataText='No se encontraron registros'
                        pageText='Página'
                        ofText='de'
                        rowsText='filas'
                        pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                        style={{
                            fontSize: "15px"
                        }} 
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default DeliveryDespacho;